import { render, staticRenderFns } from "./MainPage.vue?vue&type=template&id=380df285"
import script from "./MainPage.js?vue&type=script&lang=js&external"
export * from "./MainPage.js?vue&type=script&lang=js&external"
import style0 from "./MainPage.vue?vue&type=style&index=0&id=380df285&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports